import { useParams, Outlet } from 'react-router-dom';

import BackButton from '@/components/common/BackButton';
import Page from '@/components/layout/Page';
import PageLoading from '@/components/layout/PageLoading';
import Stepper from '@/components/common/Stepper';
import Error from '@/components/common/Error';

import { useCart } from '@/data/cart';
import { useCheckoutStructure } from '@/data/checkout';

const CheckoutPage = () => {
  const params = useParams();
  const cart = useCart(params.cartId);
  const checkoutStructure = useCheckoutStructure(params.cartId);

  if (cart.isLoading && !cart.data) {
    return <PageLoading />;
  }
  if (checkoutStructure.isLoading && !checkoutStructure.data) {
    return <PageLoading />;
  }

  if (cart.error) {
    return (
      <Page>
        <Error error="Error Loading Cart" />
      </Page>
    );
  }
  if (checkoutStructure.error) {
    return (
      <Page>
        <Error error="Error Loading Checkout Structure" />
      </Page>
    );
  }

  return (
    <Page>
      <BackButton to={`/cart/${params.cartId}`} />
      <div className="p-6 text-center">
        <h1 className="text-3xl font-bold mb-4">Checkout</h1>
      </div>
      <div className="px-6">
        <Stepper
          steps={checkoutStructure.data.steps.map((s) => s.title)}
          currentStep={
            checkoutStructure.data.steps.find(
              (s) => s.stepKey === params.stepKey
            )?.index
          }
        />
      </div>
      <Outlet />
      <div className="flex justify-center py-8"></div>
    </Page>
  );
};

export default CheckoutPage;
